import React, { useState, useEffect } from "react";

/** Components */
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Dialog, Button, ButtonGroup } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import InvoicePreview from "./invPreview";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import FileInput from "../../commons/FileInput.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
/** Icons */

/** Api & Function */
import { getInvoiceForm, getProductUnit, checkSaleOrder, checkPrice, getInventory, getCustomers, createTruckInvoice, replaceTruckInvoice } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const initialProduct = {
  vehicle: null,
  // refueler_no: null,
  hydrant_sys: "", //nhap
  position_no: "", //nhap
  driver: "", //nhap
  cert_no: "", //nhap
  meter_before_pump: "", //nhap
  meter_after_pump: "", //nhap
  product_id: null,
  product_name: null,
  productunit_id: null,
  product_unit: null,
  unit: 21,
  density: "", //nhap
  temp: "", //nhap
  d15: "",
  vcf: "",
  wcf: "",
  l15: "",
  kg: "",
  lit: "",
  gallon: "",
  quantity: null,
  price_unit: null,
  amount: null,
  price_id: null,
  // vehicle_id: null,
  price_no: null,
};
const initialInputData = {
  form: null,
  customer: null,
  date: moment(Date.now()).format("YYYY-MM-DD"),
  inventory: null,
  saleorder: null,
  contract_no: "",
  contract_date: moment(Date.now()).format("YYYY-MM-DD"),
  cert_no: "",
  vehicle: null,
  transport_company: null,
  driver: null,
  route: "",
  note: "",
  customs_declaration: "",
  airline: null,
  addhoc_shippedTo: "",
  flight: null,
  start_time: moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"),
  end_time: moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"),
  code_aircraft: "",
  aircraft_type: null,
  invoiceproducts: [initialProduct],
  method: 1,
  quantity: "", // so luong giao dich
  //
  whltt: "",
  whl15: "",
  whkg: "",
  billltt: "",
  govuom: null,
  billl15: "",
  billkg: "",
  gswuom: null,
  isManuallyEdit: false,
};
function CreateInvoice() {
  const history = useHistory();
  const dispatch = useDispatch();

  //state
  const [input, setInput] = useState(initialInputData);
  const [price, setPriceData] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const dataForPreview = {
    serial: input.form,
    valid_date: input.date,
    selectedCustomer: input.customer,
    note: input.note,
    invoiceproducts: [
      {
        quantity: input.quantity,
        amount: input.quantity * price?.price_without_tax,
        kg: input.billkg * input.gswuom?.quantity,
        lit: input.billltt,
      },
    ],
    product_name: price?.product_name,
    product_unit: price?.unit_code,
    price_unit: price?.price_without_tax,
    sub_total: input.quantity * price?.price_without_tax,
    vat_rate: price?.vat_rate,
    total: (price?.vat_rate / 100 + 1) * input.quantity * price?.price_without_tax,
    priceData: price,
  };
  //boiler plate
  const { enqueueSnackbar } = useSnackbar();
  const [t] = useTranslation();
  const location = useLocation();
  //redux state
  const user = useSelector((state) => state.user.data);

  //method
  const handleSubmit = async () => {
    let object = {
      formno: input.form?.form,
      serial: input.form?.series,
      invoiceform_id: input.form?.id,
      saletype_id: 3,
      loadingtype_id: 3,
      currency: price?.currency_code,
      valid_date: input.date,
      customer_id: input.customer?.id,
      customer_name: input.customer?.name,
      customer_tax: input.customer?.tax_code,
      customer_address: input.customer?.address,
      inventory_id: input.inventory?.id,
      // vehicle_id: input.vehicle?.id,
      // refueler_no: input.vehicle?.license_plate,
      // note: input.note,

      product_name: price?.product_name,
      product_id: price?.product_id,
      productunit_code: price?.unit_code,
      productunit_id: price?.unit_id,

      whltt: input.whltt,
      whl15: input.whl15,
      whkg: input.whkg,
      govuom: input.govuom?.id,
      gswuom: input.gswuom?.id,
      billltt: input.billltt,
      billl15: input.billl15,
      billkg: input.billkg,
      billqty: input.quantity,
      transagent: input.vehicle?.provider_id,
      contract_no: input.contract_no,
      contract_date: input.contract_date,
      cert_no: input.cert_no,
      route: input.route,
      price_no: price?.price_without_tax,
      sourcing: 21,
      saleorder_id:
        input.saleorder?.loading_info &&
        JSON.parse(input.saleorder.loading_info)?.find((item) => item.saleType === 3 && item.loadingTypes === 3 && (item.company === -1 || item.company === user.organization_id))?.id_loadingInfo,
      saleorderpr_id: input.saleorder?.id,
      price_id: price?.id,
    };
    const promise =
      input.image &&
      new Promise((res, rej) => {
        const fr = new FileReader();
        fr.readAsDataURL(input.image);
        fr.onload = () => {
          object.pre_ft = fr.result;
          res();
        };
      });
    if (input.image) await promise;
    if (location.state) return replaceTruckInvoice(location.state.id, object);
    return createTruckInvoice(object);
  };
  const handleSubmitResponse = (res) => {
    if (res.code === 200) history.push(`/invoices/${res.data?.id}?type=NAPR`);
  };

  // effect
  useEffect(() => {
    //check price
    setPriceData(null);
    if (!input.inventory || !input.date || !input.customer) return;
    checkPrice({
      valid_date: input.date,
      saletype_id: 3,
      inventory_id: input.inventory.id,
      customer_id: input.customer.id,
    }).then((res) => {
      if (res.code === 200) {
        setPriceData(res.data);
        if (!res.data) enqueueSnackbar("Hệ thống chưa khai báo giá bán hàng", { variant: "warning" });
      } else enqueueSnackbar(res.message);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.customer, input.date, input.inventory]);
  useEffect(() => {
    if (!location.state) return;
    setInput((prev) => ({
      ...prev,
      date: moment(location.state.valid_date).format("YYYY-MM-DD"),
      contract_no: location.state.contract_no || "",
      route: location.state.route || "",
      note: location.state.invoiceproducts[0]?.note || "",
      cert_no: location.state.invoiceproducts[0]?.cert_no || "",
      whkg: location.state.whKG || "",
      whl15: location.state.whL15 || "",
      whltt: location.state.whLTT || "",
      billkg: location.state.billKG || "",
      quantity: location.state.sub_quantity,
      billl15: location.state.billL15 || "",
      billltt: location.state.billLTT,
    }));
  }, [location]);

  useEffect(() => {
    dispatch(setHeaderTitle(location.state ? "PHÁT HÀNH THAY THẾ HOÁ ĐƠN NỘI ĐỊA XE BỒN" : "TẠO HOÁ ĐƠN NỘI ĐỊA XE BỒN"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {/* <h1>{t(location.state ? "Phát hành thay thế hóa đơn nội địa xe bồn" : "Tạo hóa đơn nội địa xe bồn")}</h1> */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "20px", margin: 5, marginTop: 15 }}>
        <FilterBy
          getDataFunc={() => getCustomers({ status: 1 })}
          value={input.customer}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue, saleorder: null, flight: null, isManuallyEdit: true }))}
          label={t("Khách hàng")}
          triggerSetDefaultFunc={Boolean(location.state)}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.id == location.state.customer_id) }))}
        />
        <FilterBy
          getDataFunc={() => getInventory({ organization_id: user?.organization_id, status: 1 })}
          triggerGetDataFunc={Boolean(user)}
          filter={(option) => option.whtype !== 1 && user?.organization_id === option.organization_id}
          value={input.inventory}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, inventory: newValue, saleorder: null, isManuallyEdit: true }))}
          label={t("Kho xuất")}
          triggerSetDefaultFunc={Boolean(location.state)}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, inventory: option.find((item) => item.id == location.state.inventory_id) }))}
        />
        <CustomDatePicker format="DD/MM/YYYY" label={t("Ngày")} value={input.date} onChange={(value) => setInput((prev) => ({ ...prev, date: value, saleorder: null, isManuallyEdit: true }))} />
        <FilterBy
          getDataFunc={() =>
            checkSaleOrder({
              customer_id: input.customer.id,
              invoice_type: 1,
              saletype: 3,
              loadingtype: 3,
              valid_date: moment(input.date).format("YYYY-MM-DD"),
              inventory_id: input.inventory.id,
              status: 1,
            }).then((res) => {
              if (res.code === 200) {
                if (!res.data?.length) enqueueSnackbar(`Không có hợp đồng bán cho ngày ${input.date && moment(input.date).format("DD/MM/YYYY")}`, { variant: "warning" });
              } else enqueueSnackbar(res.message);
              return res;
            })
          }
          getDataDependencies={[input.inventory, input.customer, input.date]}
          disabled={!input.customer || !input.inventory || !input.date}
          triggerGetDataFunc={input.customer && input.inventory && input.date}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, saleorder: option.find((item) => item.id == location.state.saleorderpr_id) }))}
          triggerSetDefaultFunc={Boolean(location.state && !input.isManuallyEdit)}
          value={input.saleorder}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, saleorder: newValue, isManuallyEdit: true }))}
          getOptionLabel={(option) => option.so_no || ""}
          label="Số đơn hàng"
        />
        <FilterBy
          getDataFunc={() => getInvoiceForm({ status: 1 })}
          value={input.form}
          getOptionLabel={(option) => `${option.form} - ${option.series}` || ""}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, form: newValue, isManuallyEdit: true }))}
          label={t("Form số")}
          triggerSetDefaultFunc={Boolean(location.state)}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, form: option.find((item) => item.form === location.state.form_no && item.series === location.state.serial) }))}
        />
        <FileInput label={t("Ảnh")} fullWidth accept="image/*" value={input.image} onChange={(file) => setInput((prev) => ({ ...prev, image: file }))} />
      </div>
      {/* product table */}
      <TableContainer sx={{ marginTop: "20px", textAlign: "center" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Số lượng LTT</TableCell>
              <TableCell>ĐVT thể tích</TableCell>
              <TableCell>Số lượng L15</TableCell>
              <TableCell>Số lượng Kg</TableCell>
              <TableCell>ĐVT T/lượng</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Kho xuất</TableCell>
              <TableCell>
                <TextField
                  inputProps={{ style: { textAlign: "center" } }}
                  fullWidth
                  type="number"
                  value={input.whltt}
                  onChange={(e) =>
                    e.target.value >= 0 &&
                    setInput((prev) => ({ ...prev, whltt: e.target.value, billltt: prev.govuom ? Math.round(e.target.value / prev.govuom.quantity) : prev.billltt, isManuallyEdit: true }))
                  }
                />
              </TableCell>
              <TableCell>Liter</TableCell>
              <TableCell>
                <TextField
                  inputProps={{ style: { textAlign: "center" } }}
                  fullWidth
                  type="number"
                  value={input.whl15}
                  onChange={(e) => e.target.value >= 0 && setInput((prev) => ({ ...prev, whl15: e.target.value, billl15: e.target.value, isManuallyEdit: true }))}
                />
              </TableCell>
              <TableCell>
                <TextField
                  inputProps={{ style: { textAlign: "center" } }}
                  fullWidth
                  type="number"
                  value={input.whkg}
                  onChange={(e) =>
                    e.target.value >= 0 &&
                    setInput((prev) => ({ ...prev, whkg: e.target.value, billkg: prev.gswuom ? Math.round(e.target.value / prev.gswuom.quantity) : prev.billkg, isManuallyEdit: true }))
                  }
                />
              </TableCell>
              <TableCell>KG</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Nhập xe</TableCell>
              <TableCell>
                <TextField
                  inputProps={{ style: { textAlign: "center" } }}
                  fullWidth
                  type="number"
                  value={input.billltt}
                  onChange={(e) => e.target.value >= 0 && setInput((prev) => ({ ...prev, billltt: e.target.value, isManuallyEdit: true }))}
                />
              </TableCell>
              <TableCell>
                <FilterBy
                  inputProps={{ style: { textAlign: "center" } }}
                  disableClearable
                  getDataFunc={() => getProductUnit({ status: 1 })}
                  filter={(item) => ["LTT", "BBL", "Gallon", "L15"].includes(item.code)}
                  setDefaultFunc={(option) =>
                    setInput((prev) => ({
                      ...prev,
                      govuom: option.find((item) => (input.isManuallyEdit ? (price ? item.id == price.unit : item.id == 21) : location.state ? item.id == location.state.govUoM : item.id == 21)),
                    }))
                  }
                  setDefaultDependencies={[price]}
                  triggerSetDefaultFunc
                  value={input.govuom}
                  getOptionLabel={(option) => option.shortname}
                  onChange={(e, newValue) => setInput((prev) => ({ ...prev, govuom: newValue, billltt: Math.round(prev.whltt / newValue.quantity), isManuallyEdit: true }))}
                />
              </TableCell>
              <TableCell>
                <TextField
                  inputProps={{ style: { textAlign: "center" } }}
                  fullWidth
                  type="number"
                  value={input.billl15}
                  onChange={(e) => e.target.value >= 0 && setInput((prev) => ({ ...prev, billl15: e.target.value, isManuallyEdit: true }))}
                />
              </TableCell>
              <TableCell>
                <TextField
                  inputProps={{ style: { textAlign: "center" } }}
                  fullWidth
                  value={input.billkg}
                  type="number"
                  onChange={(e) => e.target.value >= 0 && setInput((prev) => ({ ...prev, billkg: e.target.value, isManuallyEdit: true }))}
                />
              </TableCell>
              <TableCell>
                <FilterBy
                  inputProps={{ style: { textAlign: "center" } }}
                  getDataFunc={() => getProductUnit({ status: 1 })}
                  disableClearable
                  filter={(item) => ["KG", "MT", "LTon", "STon"].includes(item.code)}
                  setDefaultFunc={(option) => setInput((prev) => ({ ...prev, gswuom: option.find((item) => (location.state ? item.id == location.state.gswUoM : item.id == 31)) }))}
                  triggerSetDefaultFunc
                  value={input.gswuom}
                  getOptionLabel={(option) => option.shortname}
                  onChange={(e, newValue) => setInput((prev) => ({ ...prev, gswuom: newValue, billkg: Math.round(prev.whkg / newValue.quantity), isManuallyEdit: true }))}
                />
              </TableCell>
            </TableRow>
            <TableRow style={{ borderTop: "15px solid lightgray" }}>
              <TableCell>
                Hàng bán
                <div style={{ margin: "auto 5px", fontWeight: "bold" }}>&nbsp;{price?.product_name}&nbsp;</div>
              </TableCell>
              <TableCell>
                Đơn vị tính
                <div style={{ margin: "auto 5px", fontWeight: "bold" }}>&nbsp;{price?.unit_code}&nbsp;</div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 300 }}>
                  SL giao dịch
                  <TextField
                    inputProps={{ style: { textAlign: "center" } }}
                    type="number"
                    onChange={(e) => e.target.value >= 0 && setInput((prev) => ({ ...prev, quantity: e.target.value, isManuallyEdit: true }))}
                    value={input.quantity}
                  />
                </div>
              </TableCell>
              <TableCell colSpan={1}>
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 300 }}>
                  Đơn giá
                  <div style={{ margin: "auto 5px", fontWeight: "bold" }}>&nbsp;{price?.price_without_tax?.toLocaleString()}&nbsp;</div>
                </div>
              </TableCell>
              <TableCell colSpan={2}>
                <div style={{ display: "flex", flexDirection: "column", maxWidth: 300 }}>
                  Thành tiền
                  <div style={{ margin: "auto 5px", fontWeight: "bold" }}>{(input.quantity * price?.price_without_tax || 0).toLocaleString()}</div>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <div align="left">
        {/* button is disabled if required field is empty */}
        <ButtonGroup style={{ margin: 5 }}>
          <Button variant="contained" onClick={() => setDialogOpen(true)}>
            {t("Xem trước")}
          </Button>
          <ButtonWithAPICall api={handleSubmit} response={handleSubmitResponse} variant="contained" color="info">
            {t(location.state ? "Phát hành thay thế" : "Tạo hóa đơn")}
          </ButtonWithAPICall>
        </ButtonGroup>
      </div>
      <Dialog maxWidth={false} fullWidth={true} scroll="body" onClose={() => setDialogOpen(false)} open={dialogOpen}>
        <InvoicePreview data={dataForPreview} />
      </Dialog>
    </div>
  );
}
export default CreateInvoice;
